"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.StyledSmallTable = exports.StyledTable = exports.Root = exports.classes = void 0;
const Table_1 = __importDefault(require("@mui/material/Table"));
const TableCell_1 = require("@mui/material/TableCell");
const TableRow_1 = require("@mui/material/TableRow");
const styles_1 = require("@mui/material/styles");
const PREFIX = "Table";
exports.classes = {
    noBorder: `${PREFIX}-noBorder`,
    evenColor: `${PREFIX}-evenColor`,
    oddColor: `${PREFIX}-oddColor`,
    rowNoColor: `${PREFIX}-rowNoColor`,
    separator: `${PREFIX}-separator`,
    item: `${PREFIX}-item`,
    description: `${PREFIX}-description`,
    itemevenColor: `${PREFIX}-itemevenColor`,
    itemoddColor: `${PREFIX}-itemoddColor`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    [`.${exports.classes.noBorder}`]: {
        border: 0,
        "& tbody": {
            "& tr": {
                "& td": {
                    borderBottom: "0px"
                }
            }
        }
    },
    [`.${exports.classes.evenColor}`]: {
        borderTop: `1px solid ${theme.colours.storm}`,
        "& tbody": {
            "& tr": {
                "&:nth-of-type(even)": {
                    backgroundColor: theme.colours.pearl
                }
            }
        }
    },
    [`.${exports.classes.oddColor}`]: {
        borderTop: "none",
        "& tbody": {
            "& tr": {
                "&:nth-of-type(odd)": {
                    backgroundColor: theme.colours.pearl
                }
            }
        }
    },
    [`.${exports.classes.rowNoColor}`]: {
        "& tbody": {
            "& tr": {
                borderTop: `1px solid ${theme.colours.storm}`,
                "&:first-of-type": {
                    borderTop: "none"
                }
            }
        }
    },
    [`.${exports.classes.separator}`]: {
        borderBottom: `1px solid ${theme.colours.storm}`
    },
    [`.${exports.classes.item}`]: {
        wordBreak: "break-all",
        margin: 0,
        padding: "16px",
        listStyle: "none"
    },
    [`.${exports.classes.description}`]: {
        margin: "0 0 16px 0",
        "&:last-child": {
            margin: 0
        }
    },
    [`.${exports.classes.itemevenColor}`]: {
        [`.${exports.classes.item}`]: {
            "&:nth-of-type(even)": {
                backgroundColor: theme.colours.pearl
            }
        }
    },
    [`.${exports.classes.itemoddColor}`]: {
        [`.${exports.classes.item}`]: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.colours.pearl
            }
        }
    },
    [`& .${TableRow_1.tableRowClasses.head}`]: {
        border: `1px solid ${theme.colours.storm}`
    },
    [`& .${TableCell_1.tableCellClasses.head}`]: {
        color: "inherit",
        padding: "16px",
        fontWeight: "bold"
    },
    [`& .${TableCell_1.tableCellClasses.body}`]: {
        padding: "1rem 16px 0.67rem",
        verticalAlign: "top",
        border: 0
    },
    [`& .${TableCell_1.tableCellClasses.head}, .${TableCell_1.tableCellClasses.body}`]: {
        fontSize: "16px",
        [theme.breakpoints.up("sm")]: {
            fontSize: "18px"
        }
    }
}));
exports.StyledTable = (0, styles_1.styled)(Table_1.default)(({ theme }) => ({
    border: `1px solid ${theme.colours.storm}`
}));
exports.StyledSmallTable = (0, styles_1.styled)("div")(({ theme }) => ({
    border: `1px solid ${theme.colours.storm}`,
    fontSize: "16px",
    [theme.breakpoints.up("sm")]: {
        fontSize: "18px"
    },
    [`&.${exports.classes.noBorder}`]: {
        border: 0
    }
}));
exports.Title = (0, styles_1.styled)("dt")({ fontWeight: "bold" });
//# sourceMappingURL=data:application/json;base64,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